import Skeleton from "@/components/skeleton/Skeleton";

interface LoadingSkeletonProps {
  height?: string | number;
  minHeight?: string;
  borderRadius?: number;
  containerClassName?: string;
  boxClassName?: string;
}

const LoadingSkeleton = ({
  height = "100%",
  minHeight = "150px",
  borderRadius = 8,
  containerClassName = "container",
  boxClassName = "",
}: LoadingSkeletonProps) => {
  return (
    <div className={containerClassName}>
      <div className={boxClassName}>
        <Skeleton height={height} radius={borderRadius} style={{ minHeight }} />
      </div>
    </div>
  );
};

export default LoadingSkeleton;
